export var isRowPreselected = function (row) { return row.status !== 'SOURCE'; };
export var isCheckboxDisabled = function (row) { return row.status === 'NO_UPDATES'; };
//# sourceMappingURL=dataStructureDialogUtils.js.map